import * as Yup from "yup";
import * as auth from "../_redux/authRedux";

import { FormattedMessage, injectIntl } from "react-intl";
import React, { useState } from "react";

import { Link } from "react-router-dom";
import { connect,useDispatch } from "react-redux";
import { login, verifyLoginTwoFactor, cekToken } from "../_redux/authCrud";
import styled from "styled-components";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import PasswordInput from "../components/PasswordInput";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  nik: "",
  password: "",
};

const LoginWrapper = styled.div`
    position: absolute;
    top: 65%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    background: rgba(30, 30, 45, 0.8);
    color: #fff;
    padding: 1.5rem;
    width: calc(100% - 2rem);
    max-width: 520px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 0.75rem;
    box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    @media only screen and (min-width: 768px){
      padding: 3rem;
      top: 50%;
    }
`;

const InputLogin = styled.input`
  border: none;
  border-bottom: 1px solid #fff;
  font-weight: bold;
  border-radius: 0;
  min-height: 52px;
  padding: 0.75rem 1rem;
  &::placeholder {
    color: #fff;
    opacity: 1;
  }
`;

const Title = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const Logos = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 10vw;
  height: 20vh;
  min-width: 80px;
  @media only screen and (min-width: 1141px){
    width: 8vw;
    height: 20vh;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
`;

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [twoFactorRequired, setTwoFactorRequired] = useState(false);
  const [code, setCode] = useState("");
  const [verifying, setVerifying] = useState(false);
  const dispatch = useDispatch();

  const completeLogin = (data, password) => {
    props.login(data, password);
    cekToken(data ? data.token : null)
      .then((data_cek) => {
        dispatch(auth.actions.cekTokenAuth({ statusToken: data_cek.status, isExpired: data_cek.data.isexpired }));
      })
      .catch((error) => {
        dispatch(auth.actions.cekTokenAuth({ statusToken: error.status, isExpired: true }));
      });
  };

  const submitTwoFactor = (e) => {
    e.preventDefault();
    setVerifying(true);
    verifyLoginTwoFactor(formik.values.nik, formik.values.password, code)
      .then(({ data }) => {
        completeLogin(data, formik.values.password);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Kode salah, coba lagi.");
      })
      .finally(() => setVerifying(false));
  };
  const LoginSchema = Yup.object().shape({
    nik: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  
  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting , setErrors}) => {
      enableLoading();
      setTimeout(() => {
        login(values.nik, values.password)
          .then(({ data }) => {
            if (data && data.two_factor_required) {
              disableLoading();
              setTwoFactorRequired(true);
              return;
            }
            disableLoading();
            completeLogin(data, values.password);
          })
          .catch((errors) => {
            disableLoading();
            toast.error(errors.response.data.error);
            setSubmitting(false);
            setStatus(
              intl.formatMessage({
                id: "AUTH.VALIDATION.INVALID_LOGIN",
              })
            );
          });
      }, 1000);
    },
  });

  return (
    <Wrapper>
      <Logos>
        <img
          src={`${toAbsoluteUrl("/media/logos/mynet.png")}`}
          alt="MYNET"
        />
      </Logos>
      <Title>
        <h4>Sistem Informasi Mynet Terpadu</h4>
      </Title>
      <LoginWrapper>
        {!twoFactorRequired ? (
          <>
            <h1 className="mb-2"><FormattedMessage id="AUTH.LOGIN.TITLE" /> </h1>
            <p className="text-white-50 mb-6">
              Masukkan NIK dan password untuk melanjutkan.
            </p>
            <form className="form row" id="kt_login_signin_form" onSubmit={formik.handleSubmit}>
              <div className="form-group col-12">
                <InputLogin
                  className="form-control text-white bg-white-o-5"
                  type="text"
                  placeholder="NIK"
                  name="nik"
                  autoComplete="username"
                  {...formik.getFieldProps("nik")}
                />
                {formik.touched.nik && formik.errors.nik ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.nik}</div>
                </div>
              ) : null}
              </div>
              <div className="form-group col-12">
                <PasswordInput
                  className="form-control text-white bg-white-o-5 py-3 px-4"
                  placeholder="Password"
                  name="password"
                  autoComplete="current-password"
                  {...formik.getFieldProps("password")}
                />
                {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
              </div>
              <div className="form-group col-md-6 col-sm-12 col-xs-12">
                <div className="checkbox-inline">
                  <label className="checkbox checkbox-outline checkbox-white text-white m-0">
                    <input type="checkbox" name="remember" />
                    <span></span>
                    Remember me
                  </label>
                </div>
              </div>
              <div className="form-group col-md-6 col-sm-12 col-xs-12 text-right">
                <Link to="/auth/forgot-password"
                  id="kt_login_forgot_password"
                  className="text-white font-weight-bold"
                >
                  Forgot Password ?
                </Link>
              </div>
              <div className="form-group col-12">
                <button
                  type="submit"
                  id="kt_login_signin_submit"
                  className="btn btn-success btn-block mx-auto"
                  disabled={formik.isSubmitting}
                >
                  <span>Login</span>
                  {loading && <span className="ml-3 spinner spinner-white"></span>}
                </button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h1>Verifikasi Dua Langkah</h1>
            <p className="text-white-50 mb-3">
              Masukkan kode 6 digit dari aplikasi autentikator Anda.
            </p>
            <form className="form row" id="kt_login_2fa_form" onSubmit={submitTwoFactor}>
              <div className="form-group col-12">
                <InputLogin
                  className="form-control text-white bg-white-o-5"
                  type="text"
                  placeholder="Kode 6 digit"
                  maxLength={6}
                  autoFocus
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
              <div className="form-group col-6">
                <button
                  type="button"
                  className="btn btn-warning btn-block"
                  onClick={() => {
                    setTwoFactorRequired(false);
                    setCode("");
                  }}
                >
                  Back
                </button>
              </div>
              <div className="form-group col-6">
                <button
                  type="submit"
                  className="btn btn-success btn-block"
                  disabled={verifying || code.length < 6}
                >
                  <span>Verifikasi</span>
                  {verifying && <span className="ml-3 spinner spinner-white"></span>}
                </button>
              </div>
            </form>
          </>
        )}
      </LoginWrapper>
    </Wrapper>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
